import { render, staticRenderFns } from "./confirmjanflow.vue?vue&type=template&id=4ff65ff9&lang=pug&"
import script from "./confirmjanflow.vue?vue&type=script&lang=js&"
export * from "./confirmjanflow.vue?vue&type=script&lang=js&"
import style0 from "./confirmjanflow.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports